/* eslint-disable import/no-cycle */
import React from 'react';
import { WrappedFunctionProps } from '../types';
import { ColorField as FormColorField } from '../../apiForm/form/input';

export default function ColorAlphaField({
  inputKey,
  translation,
  language,
  control,
}: WrappedFunctionProps) {
  return (
    <FormColorField
      control={control}
      name={inputKey}
      label={translation?.title?.[language] || inputKey}
      helperText={translation?.description?.[language]}
      withPrefix
      withAlpha
    />
  );
}
